import React from 'react';
import { Button, Tooltip, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons'; 

interface ExportAgCSVButtonProps {
  gridRef: React.RefObject<any>;
  fileName?: string;
  skipColumns?: string[];
}

const ExportAgCSVButton: React.FC<ExportAgCSVButtonProps> = ({
  gridRef,
  fileName = 'export',
  skipColumns = [],
}) => {

  const handleExportCSV = () => {
    if (!gridRef.current?.api) {
      message.error('Grid is not ready');
      return;
    }
    const allColumns = gridRef.current?.api.getAllGridColumns();
    const excludedKeys = new Set(['actions', ...skipColumns]);

    const columnKeysToExport = allColumns
      ?.filter((col: any) => {
        const colDef = col.getColDef();
        const field = colDef.field;
        const colId = col.getColId();
        if (!field && !colId) return false;
        if (field && excludedKeys.has(field)) return false;
        if (colId && excludedKeys.has(colId)) return false;
        return true;
      })
      .map((col: any) => col.getColId());
    gridRef.current?.api.exportDataAsCsv({
      fileName: `${fileName}.csv`,
      columnKeys: columnKeysToExport,
    });
  };
  return (
    <Tooltip title="Download CSV">
      <Button
        shape="circle"
        icon={<DownloadOutlined />}
        onClick={handleExportCSV}
      />
    </Tooltip>
  );
};

export default ExportAgCSVButton;
